// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "sub-panel-context": {
            "type": "object"
        },
        "src": {
            "type": "string"
        }
    },
    "_viewModelId": "DesJTViewer",
    "_uniqueViewModelId": "DesJTViewer",
    "ctx": {}
};

    /*
    <div class="pdf-viewer-styling">
    <des-catalog-jt-viewer jtviewersrc="{{props.subPanelContext.viewerSRC || props.src}}">
    </des-catalog-jt-viewer>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="pdf-viewer-styling">
        <des-catalog-jt-viewer jtviewersrc={AwParseService.instance( "props.subPanelContext.viewerSRC || props.src" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        </des-catalog-jt-viewer>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;